const escapeCSV = (value) => {
  if (value === null || value === undefined) return "";
  const stringValue = value.toString().replace(/"/g, '""');
  if (stringValue.includes(",") || stringValue.includes("\n")) {
    return `"${stringValue}"`;
  }
  return stringValue;
};

const normalizeAllergensToString = (allergens) => {
  if (!allergens) return "";
  if (Array.isArray(allergens)) return allergens.join(",");
  if (typeof allergens === "string") {
    return allergens
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
      .join(",");
  }
  try {
    return String(allergens);
  } catch (e) {
    return "";
  }
};

export const parseOrganizationJSON = (data) => {
  const headers = [
    "Organization Name",
    "Subdomain",
    "Timezone",
    "Station Name",
    "Station Active",
    "Station Image",
    "Station Sound",
    "Order Restriction",
    "Order Max Threshold",
    "Order Min Threshold",
    "Info",
    "Midnight Autocomplete",
    "Is Multi",
    "Sub-stations",
    "Option Group Name",
    "Option Group Order",
    "Option Group Info",
    "Allow Multiple",
    "Max Multiple",
    "Option Name",
    "Option Order",
    "Option Cost",
    "Option Visible",
    "Option Image",
    "Option Allergens",
  ];

  const rows = [];

  data.stations.forEach((station) => {
    // normalize various possible representations of is_multi
    const rawIsMulti =
      station.is_multi !== undefined ? station.is_multi : station.isMulti;
    const isMulti =
      rawIsMulti === true ||
      rawIsMulti === 1 ||
      rawIsMulti === "1" ||
      rawIsMulti === "true";
    const isMultiStr = isMulti ? "true" : "false";
    const subStationsRaw = station.sub_stations || station.subStations || [];
    const subStationsStr = Array.isArray(subStationsRaw)
      ? subStationsRaw
          .map((item) => (typeof item === "string" ? item : item?.name || ""))
          .filter(Boolean)
          .join("|")
      : "";
    if (!station.option_groups || station.option_groups.length === 0) {
      rows.push([
        data.name,
        data.subdomain,
        data.timezone,
        station.name,
        station.active,
        station.image_name || "",
        station.sound_name || "",
        station.order_restriction,
        station.order_max_threshold != null ? station.order_max_threshold : "",
        station.order_min_threshold != null ? station.order_min_threshold : "",
        station.info || "",
        station.midnight_autocomplete ? "true" : "false",
        isMultiStr,
        subStationsStr,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]);
    } else {
      station.option_groups.forEach((group) => {
        if (!group.options || group.options.length === 0) {
          rows.push([
            data.name,
            data.subdomain,
            data.timezone,
            station.name,
            station.active,
            station.image_name || "",
            station.sound_name || "",
            station.order_restriction,
            station.order_max_threshold != null
              ? station.order_max_threshold
              : "",
            station.order_min_threshold != null
              ? station.order_min_threshold
              : "",
            station.info || "",
            station.midnight_autocomplete ? "true" : "false",
            isMultiStr,
            subStationsStr,
            group.name,
            group.order,
            group.info || "",
            group.allow_multiple,
            group.max_multiple || "",
            "",
            "",
            "",
            "",
            "",
          ]);
        } else {
          group.options.forEach((option) => {
            rows.push([
              data.name,
              data.subdomain,
              data.timezone,
              station.name,
              station.active,
              station.image_name || "",
              station.sound_name || "",
              station.order_restriction,
              station.order_max_threshold != null
                ? station.order_max_threshold
                : "",
              station.order_min_threshold != null
                ? station.order_min_threshold
                : "",
              station.info || "",
              station.midnight_autocomplete ? "true" : "false",
              isMultiStr,
              subStationsStr,
              group.name,
              group.order,
              group.info || "",
              group.allow_multiple,
              group.max_multiple || "",
              option.name,
              option.order,
              option.cost,
              option.visible,
              option.image_name || "",
              normalizeAllergensToString(option.allergens),
            ]);
          });
        }
      });
    }
  });

  const csvContent = [
    headers.join(","),
    ...rows.map((row) => row.map(escapeCSV).join(",")),
  ].join("\n");

  return csvContent;
};

export const exportStationToCsv = (station) => {
  const headers = [
    "Station Name",
    "Station Active",
    "Station Image",
    "Station Sound",
    "Order Restriction",
    "Order Max Threshold",
    "Order Min Threshold",
    "Is Multi",
    "Sub-stations",
    "Option Group Name",
    "Option Group Info",
    "Option Group Order",
    "Allow Multiple",
    "Max Multiple",
    "Option Name",
    "Option Order",
    "Option Cost",
    "Option Visible",
    "Option Image",
    "Option Allergens",
  ];

  let csvContent = headers.join(",") + "\n";
  if (!station) return csvContent;

  // normalize shapes: array, { station } (array or object), or plain object
  const s =
    Array.isArray(station) && station.length > 0
      ? station[0]
      : Array.isArray(station?.station) && station.station.length > 0
        ? station.station[0]
        : station.station || station;
  const groups = s.option_groups || s.optionGroups || [];
  const isMulti =
    s.is_multi !== undefined
      ? s.is_multi
      : s.isMulti !== undefined
        ? s.isMulti
        : false;
  const subStations = s.sub_stations || s.subStations || [];
  const isMultiStr = isMulti ? "true" : "false";
  const subStationsStr =
    (Array.isArray(subStations) ? subStations : [])
      .map((item) => (typeof item === "string" ? item : item?.name || ""))
      .filter(Boolean)
      .join("|") || "";

  if (!groups.length) {
    const row = [
      s.name,
      s.active,
      s.image_name ?? "",
      s.sound_name ?? "",
      s.order_restriction ?? "",
      s.order_max_threshold ?? "",
      s.order_min_threshold ?? "",
      isMultiStr,
      subStationsStr,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ];
    csvContent += row.map(escapeCSV).join(",") + "\n";
    return csvContent;
  }

  groups.forEach((group) => {
    const options = group.options || [];
    if (!options.length) {
      const row = [
        s.name,
        s.active,
        s.image_name ?? "",
        s.sound_name ?? "",
        s.order_restriction ?? "",
        s.order_max_threshold ?? "",
        s.order_min_threshold ?? "",
        isMultiStr,
        subStationsStr,
        group.name ?? "",
        group.info ?? "",
        group.order ?? "",
        group.allow_multiple ?? "",
        group.max_multiple ?? "",
        "",
        "",
        "",
        "",
        "",
        "",
      ];
      csvContent += row.map(escapeCSV).join(",") + "\n";
    } else {
      options.forEach((option) => {
        const row = [
          s.name,
          s.active,
          s.image_name ?? "",
          s.sound_name ?? "",
          s.order_restriction ?? "",
          s.order_max_threshold ?? "",
          s.order_min_threshold ?? "",
          isMultiStr,
          subStationsStr,
          group.name ?? "",
          group.info ?? "",
          group.order ?? "",
          group.allow_multiple ?? "",
          group.max_multiple ?? "",
          option.name ?? "",
          option.order ?? "",
          option.cost ?? "",
          option.visible ?? "",
          option.image_name ?? "",
          normalizeAllergensToString(option.allergens),
        ];
        csvContent += row.map(escapeCSV).join(",") + "\n";
      });
    }
  });

  return csvContent;
};

export function exportOptionGroupToCsv(optionGroup) {
  const headers = [
    "Option Group Name",
    "Option Group Order",
    "Allow Multiple",
    "Max Multiple",
    "Option Group Info",
    "Option Name",
    "Option Order",
    "Option Cost",
    "Option Visible",
    "Option Image",
    "Option Allergens",
  ];

  let csvContent = headers.join(",") + "\n";

  optionGroup.options.forEach((option) => {
    const row = [
      optionGroup.name,
      optionGroup.order,
      optionGroup.allow_multiple,
      optionGroup.max_multiple ?? "",
      optionGroup.info ?? "",

      option.name,
      option.order,
      option.cost,
      option.visible,
      option.image_name ?? "",
      normalizeAllergensToString(option.allergens),
    ];

    csvContent += row.map(escapeCSV).join(",") + "\n";
  });

  if (optionGroup.options.length === 0) {
    const row = [
      optionGroup.name,
      optionGroup.order,
      optionGroup.allow_multiple,
      optionGroup.max_multiple ?? "",
      optionGroup.info ?? "",
      "",
      "",
      "",
      "",
      "",
    ];
    csvContent += row.map(escapeCSV).join(",") + "\n";
  }

  return csvContent;
}

function parseCsvLine(line) {
  const result = [];
  let curr = "";
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    if (char === '"' && line[i + 1] === '"') {
      curr += '"';
      i++;
    } else if (char === '"') {
      inQuotes = !inQuotes;
    } else if (char === "," && !inQuotes) {
      result.push(curr);
      curr = "";
    } else {
      curr += char;
    }
  }
  result.push(curr);
  return result;
}

function parseCsvTextToRows(text) {
  const lines = text.split(/\r?\n/).filter((line) => line.trim() !== "");
  return lines.map(parseCsvLine);
}

function buildRowObject(headers, row) {
  const obj = {};
  headers.forEach((header, i) => {
    obj[header] = row[i] ?? "";
  });
  return obj;
}

const toNonNegativeInt = (value, fallback = 0) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
};

const toNonNegativeFloat = (value, fallback = 0) => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
};

const toBoolean = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "1";
  }
  return false;
};

export const parseOrganizationCSVToJson = (csvText) => {
  const rows = parseCsvTextToRows(csvText);
  const headers = rows.shift();

  const json = {
    name: "",
    subdomain: "",
    timezone: "",
    stations: [],
  };

  const stationMap = {};

  rows.forEach((rawRow) => {
    const row = buildRowObject(headers, rawRow);

    if (!json.name) {
      json.name = row["Organization Name"];
      json.subdomain = row["Subdomain"];
      json.timezone = row["Timezone"];
    }

    const stationKey = row["Station Name"];
    if (!stationMap[stationKey]) {
      const stationSubStations = (row["Sub-stations"] || "")
        .split("|")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((name) => ({ id: null, name }));

      stationMap[stationKey] = {
        name: row["Station Name"],
        active: toNonNegativeInt(row["Station Active"], 0),
        image_name: row["Station Image"] || null,
        sound_name: row["Station Sound"] || null,
        order_restriction: row["Order Restriction"],
        order_max_threshold:
          row["Order Max Threshold"] !== undefined &&
          row["Order Max Threshold"] !== ""
            ? toNonNegativeInt(row["Order Max Threshold"], null)
            : null,
        order_min_threshold:
          row["Order Min Threshold"] !== undefined &&
          row["Order Min Threshold"] !== ""
            ? toNonNegativeInt(row["Order Min Threshold"], null)
            : null,
        info: row["Info"] || "",
        midnight_autocomplete: toBoolean(row["Midnight Autocomplete"]),
        is_multi: toBoolean(row["Is Multi"]),
        sub_stations: stationSubStations,
        option_groups: [],
      };
      json.stations.push(stationMap[stationKey]);
    }

    if (row["Option Group Name"]) {
      let group = stationMap[stationKey].option_groups.find(
        (g) => g.name === row["Option Group Name"],
      );
      if (!group) {
        const stationForGroup = stationMap[stationKey];
        const firstSubStationName =
          stationForGroup.sub_stations?.[0]?.name || stationForGroup.name || "";
        group = {
          name: row["Option Group Name"],
          order: toNonNegativeInt(row["Option Group Order"], 0),
          allow_multiple: toNonNegativeInt(row["Allow Multiple"], 0),
          max_multiple: row["Max Multiple"]
            ? toNonNegativeInt(row["Max Multiple"], 0)
            : null,
          sub_station_name: firstSubStationName,
          options: [],
          info: row["Option Group Info"] || "",
        };
        stationMap[stationKey].option_groups.push(group);
      }

      if (row["Option Name"]) {
        group.options.push({
          name: row["Option Name"],
          order: toNonNegativeInt(row["Option Order"], 0),
          cost: toNonNegativeFloat(row["Option Cost"], 0),
          visible: toNonNegativeInt(row["Option Visible"], 0),
          image_name: row["Option Image"] || null,
          note: null,
          allergens: row["Option Allergens"]
            ? String(row["Option Allergens"])
                ?.split(",")
                .map((s) => s.trim())
                .filter(Boolean)
            : [],
        });
      }
    }
  });

  return json;
};

export const parseStationCSVToJson = (csvText) => {
  const rows = parseCsvTextToRows(csvText);
  const headers = rows.shift();

  const station = {
    name: "",
    active: 0,
    image_name: null,
    sound_name: null,
    order_restriction: "",
    order_max_threshold: null,
    order_min_threshold: null,
    info: "",
    midnight_autocomplete: true,
    option_groups: [],
    is_multi: false,
    sub_stations: [],
  };

  const groupMap = {};

  rows.forEach((rawRow) => {
    const row = buildRowObject(headers, rawRow);

    if (!station.name) {
      station.name = row["Station Name"];
      station.active = toNonNegativeInt(row["Station Active"], 0);
      station.image_name = row["Station Image"] || null;
      station.sound_name = row["Station Sound"] || null;
      station.order_restriction = row["Order Restriction"];
      station.order_max_threshold =
        row["Order Max Threshold"] !== undefined &&
        row["Order Max Threshold"] !== ""
          ? toNonNegativeInt(row["Order Max Threshold"], null)
          : null;
      station.order_min_threshold =
        row["Order Min Threshold"] !== undefined &&
        row["Order Min Threshold"] !== ""
          ? toNonNegativeInt(row["Order Min Threshold"], null)
          : null;
      station.info = row["Info"] || "";
      station.midnight_autocomplete = toBoolean(row["Midnight Autocomplete"]);
      station.is_multi = toBoolean(row["Is Multi"]);
      const subsRaw = row["Sub-stations"] || "";
      station.sub_stations = subsRaw
        .split("|")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((name) => ({ id: null, name }));
    }

    if (row["Option Group Name"]) {
      const groupKey = row["Option Group Name"];
      if (!groupMap[groupKey]) {
        // determine a sensible sub_station_name for the group
        const stationFirstSubName =
          station.sub_stations && station.sub_stations.length > 0
            ? station.sub_stations[0].name
            : station.name;
        groupMap[groupKey] = {
          name: row["Option Group Name"],
          order: toNonNegativeInt(row["Option Group Order"], 0),
          allow_multiple: toNonNegativeInt(row["Allow Multiple"], 0),
          max_multiple: row["Max Multiple"]
            ? toNonNegativeInt(row["Max Multiple"], 0)
            : null,
          info: row["Option Group Info"] || "",
          sub_station_name: stationFirstSubName,
          options: [],
        };
        station.option_groups.push(groupMap[groupKey]);
      }

      if (row["Option Name"]) {
        groupMap[groupKey].options.push({
          name: row["Option Name"],
          order: toNonNegativeInt(row["Option Order"], 0),
          cost: toNonNegativeFloat(row["Option Cost"], 0),
          visible: toNonNegativeInt(row["Option Visible"], 0),
          image_name: row["Option Image"] || null,
          note: null,
          allergens: row["Option Allergens"]
            ? String(row["Option Allergens"])
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
            : [],
        });
      }
    }
  });

  return station;
};

export const parseOptionGroupCsvFile = (csvText) => {
  const rows = parseCsvTextToRows(csvText);
  const headers = rows.shift();

  if (!rows.length) throw new Error("CSV is empty");

  const optionGroup = {
    name: "",
    order: 0,
    allow_multiple: 0,
    max_multiple: null,
    options: [],
  };

  rows.forEach((rawRow) => {
    const row = buildRowObject(headers, rawRow);

    if (!optionGroup.name) {
      optionGroup.name = row["Option Group Name"];
      optionGroup.order = parseInt(row["Option Group Order"], 10);
      optionGroup.allow_multiple = parseInt(row["Allow Multiple"], 10);
      optionGroup.max_multiple = row["Max Multiple"]
        ? parseInt(row["Max Multiple"], 10)
        : null;
      optionGroup.info = row["Info"] || "";
    }

    if (row["Option Name"]) {
      optionGroup.options.push({
        name: row["Option Name"],
        order: parseInt(row["Option Order"], 10),
        cost: parseFloat(row["Option Cost"]),
        visible: parseInt(row["Option Visible"], 10),
        image_name: row["Option Image"] || null,
        note: null,
        allergens: row["Option Allergens"]
          ? String(row["Option Allergens"])
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean)
          : [],
      });
    }
  });

  return optionGroup;
};
